import { gql } from 'apollo-angular'

export const UPDATE_BILLING_CYCLE = gql`
  mutation updateBillingCycle(
    $id: Int!
    $autosave: Boolean!
    $data: mutationBillingCycleUpdateInput!
  ) {
    updateBillingCycle(id: $id, autosave: $autosave, data: $data) {
      id
      frequency
      startDate
      nextInvoicingDate
      reference
    }
  }
`
